import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import './Main.css';

function Main() {
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);
  const quotes = [
    { text: "Budget Buddy helps me learn finance terms in an easy and fun way. I've learned a lot from it and now I have a plan for my finances!", author: "John L." },
    { text: "Financle is a fun game that teaches me new finance terms with a similar format to Wordle that I use to increase my finance knowledge!", author: "Jayden N." },
    { text: "I loving using Teens Money's features as they help me become more educated in finance. A must have for all teenagers, interested in finance or not!", author: "Akash M." }
  ];

  const nextQuote = () => {
    setCurrentQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
  };

  const prevQuote = () => {
    setCurrentQuoteIndex((prevIndex) => (prevIndex - 1 + quotes.length) % quotes.length);
  };

  return (
    <>
      {/* Header Section */}
      <div style={{ backgroundColor: '#F1F8E9', padding: '50px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <p style={{ fontWeight: 'bold', fontSize: '50px', marginTop: '10px', color: '#000000', textAlign: 'left', width: '90%' }}>
          Empowering Teens' Financial Literacy
        </p>
        <p style={{ fontWeight: '500', fontSize: '25px', marginTop: '10px', color: '#000000', textAlign: 'left', width: '90%' }}>
          We offer interactive tools, personalized support, and a community-driven experience to help teens master their money and make informed financial choices.
        </p>
        
        {/* Flex container for button and social icons */}
        <div style={{ 
          width: '100%', 
          display: 'flex', 
          flexWrap: 'wrap', 
          justifyContent: 'center', 
          alignItems: 'center', 
          gap: '20px', /* Add spacing between elements */ 
          padding: '10px' 
        }}>
          {/* Top-aligned Explore Features Button */}
          <Button 
            href="#features" 
            style={{ 
              backgroundColor: '#4CAF50', 
              border: 'none', 
              padding: '10px 20px', 
              fontSize: '16px',
              flex: '0 1 auto', /* Adjust width but avoid full stretch */
              textAlign: 'center',
              width: 'auto', /* Default to auto width */
              maxWidth: '300px', /* Prevent the button from being too wide */
              minWidth: '150px', /* Ensure the button is not too narrow */
              borderRadius: '5px' /* Optional: Add rounded corners for a modern look */
            }}
          >
            Explore Features
          </Button>

          {/* Bottom-aligned Social Media & About Us Buttons */}
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            justifyContent: 'center', 
            alignItems: 'center', 
            gap: '10px' 
          }}>
            <Button 
              href="aboutus" 
              style={{ 
                marginLeft: '10px', 
                backgroundColor: '#4CAF50', 
                border: 'none', 
                padding: '10px 20px', 
                fontSize: '16px', 
                flex: '0 1 auto',
                textAlign: 'center',
                width: 'auto',
                maxWidth: '300px',
                minWidth: '150px',
                borderRadius: '5px'
              }}
            >
              About Us
            </Button>
          </div>
        </div>

      </div>


{/* Features Section */}
<div id="features" style={{ backgroundColor: '#F1F8E9', padding: '50px 20px' }}>
  <h2 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '40px' }}>
    Get Started with Teens Money
  </h2>

  {/* Features Grid */}
  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '30px',
    justifyContent: 'center',
    alignItems: 'stretch'
  }}>
    {/* Budget Buddy */}
    <div style={{
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%'
    }}>
      <div style={{ flexGrow: 1 }}>
        <h3 style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '16px' }}>Budget Buddy</h3>
        <p>
          Our AI assistant educates on personal finance concepts, offering insights into saving,
          investing, and budgeting. Input your personal expenses and income, and Budget Buddy will
          offer personalized recommendations!
        </p>
      </div>
      <Button href="/budgetbuddy" style={{ backgroundColor: '#4CAF50', border: 'none', alignSelf: 'center' }}>
        Try Now!
      </Button>
    </div>

    {/* Stock Market Game */}
    <div style={{
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%'
    }}>
      <div style={{ flexGrow: 1 }}>
        <h3 style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '16px' }}>Stock Market Game</h3>
        <p>
          Participate in a stock market game with virtual money to explore real-time trading,
          learn market strategies, and understand investing in a risk-free environment!
        </p>
      </div>
      <Button href="/stockmarketgame" style={{ backgroundColor: '#4CAF50', border: 'none', alignSelf: 'center' }}>
        Sign Up Now!
      </Button>
    </div>

    {/* Financle */}
    <div style={{
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%'
    }}>
      <div style={{ flexGrow: 1 }}>
        <h3 style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '16px' }}>Financle</h3>
        <p>
          Play a finance-themed word game similar to Wordle to guess the 5-letter finance word
          of the day. Get feedback for each letter to help you solve the puzzle!
        </p>
      </div>
      <Button href="/financle" style={{ backgroundColor: '#4CAF50', border: 'none', alignSelf: 'center' }}>
        Learn More
      </Button>
    </div>

    {/* Forum */}
    <div style={{
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%'
    }}>
      <div style={{ flexGrow: 1 }}>
        <h3 style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '16px' }}>Forum</h3>
        <p>
          Join our community forum to discuss finance topics, share tips, ask questions, and
          learn from others on their financial journey!
        </p>
      </div>
      <Button href="/forum" style={{ backgroundColor: '#4CAF50', border: 'none', alignSelf: 'center' }}>
        Join Now
      </Button>
    </div>
  </div>
</div>


      {/* Testimonials Section */}
      <div style={{ backgroundColor: '#F1F8E9', padding: '50px 20px', textAlign: 'center', position: 'relative' }}>
        <h2 style={{ fontWeight: 'bold', marginBottom: '30px' }}>Testimonials</h2>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          maxWidth: '90%',
          margin: '0 auto',
        }}>
          {/* Previous Button */}
          <Button
            onClick={prevQuote}
            style={{
              backgroundColor: '#F1F8E9',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: '10px',
            }}
          >
            <img src="images/leftarrow.png" alt="Previous" style={{ width: '30px', height: '30px' }} />
          </Button>

          {/* Testimonial Text */}
          <div style={{
            flex: '1',
            textAlign: 'center',
            padding: '20px',
            minWidth: '300px', // Ensures the testimonial box doesn't shrink
            maxWidth: '600px', // Optional: caps the width for better layout
          }}>
            <p style={{ fontStyle: 'italic', marginBottom: '10px' }}>
              "{quotes[currentQuoteIndex].text}"
            </p>
            <p style={{ fontWeight: 'bold', marginBottom: '20px' }}>- {quotes[currentQuoteIndex].author}</p>
          </div>

          {/* Next Button */}
          <Button
            onClick={nextQuote}
            style={{
              backgroundColor: '#F1F8E9',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: '10px',
            }}
          >
            <img src="images/rightarrow.png" alt="Next" style={{ width: '30px', height: '30px' }} />
          </Button>
        </div>
      </div>

      {/* Contact Section */}
      <div style={{ backgroundColor: '#F1F8E9', padding: '50px 20px', textAlign: 'center' }}>
        <h2 style={{ fontWeight: 'bold', marginBottom: '20px' }}>Contact Us</h2>
        <p>
          We're here to answer any questions and provide more information. We look forward to hearing from you!
        </p>
        <p style={{ fontWeight: 'bold', color: '#4CAF50' }}>Email us at: info@teensmoney.org</p>
      </div>
    </>
  );
}

export default Main;
